function parseLocaleNumber(txt) {
  if (!txt) return 0;

  let cleaned = txt
    .replace(/[\u202f\u00a0]/g, ' ') // thin / NB‑spaces → normal
    .replace(/[^\d.,-]/g, '') // keep only digits , . −
    .replace(/\s(?=\d)/g, ''); // strip spaces between digits

  const lastDot = cleaned.lastIndexOf('.');
  const lastComma = cleaned.lastIndexOf(',');

  if (lastDot > -1 && lastComma > -1) {
    // both symbols
    if (lastDot > lastComma) cleaned = cleaned.replace(/,/g, '');
    else cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (lastComma > -1) {
    // only comma
    const dec = cleaned.length - lastComma - 1;
    cleaned = dec === 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
  } else if (lastDot > -1) {
    // only dot
    const dec = cleaned.length - lastDot - 1;
    if (dec !== 2) cleaned = cleaned.replace(/\./g, '');
  }

  const n = parseFloat(cleaned);
  return Number.isNaN(n) ? 0 : n;
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.dataset.sub) {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    document.addEventListener('la:dn:cart:updated', function(event) {
      discount_cart_ninja_cart_total_rebuild();
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    // Note: we removed the check for `if (event.source === 'cart-items') { return; }`
    // so that onCartUpdate() always runs, even when source is 'cart-items'.
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.drawer__header'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          // After snippet replacement, fetch /cart.js for recs logic
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => {
              if (cartData.item_count > 0 && window.mountSearchSpringCartRecs) {
                window.mountSearchSpringCartRecs();
              } else {
                const recsDiv = document.getElementById('search-spring-cart-recs');
                if (recsDiv) {
                  recsDiv.innerHTML = '';
                }
              }
            })
            .catch(err => console.error('Error checking cart:', err));
        })
        .catch(e => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items .page-width');
          this.querySelector('.page-width').innerHTML = sourceQty.innerHTML;

          // After snippet replacement, fetch /cart.js for recs logic
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => {
              if (cartData.item_count > 0 && window.mountSearchSpringCartRecs) {
                window.mountSearchSpringCartRecs();
              } else {
                const recsDiv = document.getElementById('search-spring-cart-recs');
                if (recsDiv) {
                  recsDiv.innerHTML = '';
                }
              }
            })
            .catch(err => console.error('Error checking cart:', err));
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId, reload) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          const cartItem = document.getElementById(`Cart-item-${variantId}`);
          quantityElement.value = quantityElement.getAttribute('value');
          const maxInventory = cartItem.getAttribute('data-inventory-quantity');
          const trackInventory = cartItem.getAttribute('data-track-inventory');
          const maxQuantityMessage = document
            .querySelector(`#Cart-item-${variantId} .quantity-exceed-message`)
            .innerHTML.trim();
          let errorMessageQuantity = '';
          if (trackInventory != null && maxInventory > 0) {
            errorMessageQuantity = `<div class="low-stock">
                                      <span>
                                        <span>
                                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.134 1.5C10.5189 0.833333 11.4811 0.833333 11.866 1.5L19.6603 15C20.0452 15.6667 19.564 16.5 18.7942 16.5H3.20577C2.43597 16.5 1.95485 15.6667 2.33975 15L10.134 1.5Z" stroke="#1A1B1B"></path>
                                            <path d="M10.7583 11.3373L10.4058 8.1723V6.1798H11.5933V8.1723L11.2408 11.3373H10.7583ZM10.3383 13.2998V12.0498H11.6583V13.2998H10.3383Z" fill="#1A1B1B"></path>
                                          </svg>
                                        </span> ${maxQuantityMessage} </span>
                                      <span class="close-icon">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect width="17.7214" height="1.72292" rx="0.861458"
                                            transform="matrix(0.707968 0.706245 -0.707968 0.706245 1.21973 0)" fill="#1A1B1B"/>
                                          <rect width="17.7214" height="1.72292" rx="0.861458"
                                            transform="matrix(0.707968 -0.706245 0.707968 0.706245 0.233398 12.7832)" fill="#1A1B1B"/>
                                        </svg>
                                      </span>
                                    </div>`;
          }
          this.updateLiveRegions(line, errorMessageQuantity);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        }
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          let getHtmlData = parsedState.sections[section.section];
          let shippingBarCheck = document.querySelector('.shipping_bar');
          if (shippingBarCheck != null) {
            let datagetWidth = '';
            if (document.querySelector('.drawer.active .progress-done') != null) {
              datagetWidth = document.querySelector('.drawer.active .progress-done').style.width;
            } else {
              datagetWidth = document.querySelector('.free-shipping-section .progress-done').style.width;
            }
            getHtmlData = getHtmlData.replace(
              '<div class="progress-done" data-done="20" style="width: 20%;"></div>',
              '<div class="progress-done" data-done="20" style="width: ' + datagetWidth + '"></div>'
            );
          }
          elementToReplace.innerHTML = this.getSectionInnerHTML(getHtmlData, section.selector);
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        if (!window.location.href.includes('/cart')) {
          // free shipping update for minicart on quantity change
          setTimeout(function() {
            const cartDrawerShippingdigit = parseFloat(
              document
                .querySelector('.cart-drawer__shipping-msg')
                ?.getAttribute('freedigit')
                ?.match(/\d+(?:\d{3})*(?:\.\d+)?/g)
                .join('')
            );
            const cartDrawerShippingMsg = document
              .querySelector('.cart-drawer__shipping-msg')
              ?.getAttribute('limit-reach');
            const cartDrawerShippingMsgDigit = document.querySelector(
              '.cart-drawer__shipping-msg [data-left-to-spend]'
            );

            let elTwo = document.querySelector('.totals .totals__total-value');
            let totalsTotalValue = elTwo ? parseLocaleNumber(elTwo.innerText) : null;
            if (!totalsTotalValue) return;
            const currencydigit = document.getElementById('shop-currency-symbol').getAttribute('data-currency-symbol');
            const progressBar = document.querySelector('.cart-drawer__progress .progress-done');

            function updateProgressBar() {
              if (!cartDrawerShippingdigit) return;
              let progressPercentage = (totalsTotalValue / cartDrawerShippingdigit) * 100;
              progressPercentage = Math.min(progressPercentage, 100);
              if (progressPercentage >= 100) {
                if (cartDrawerShippingMsg) {
                  document.querySelector('.cart-drawer__shipping-msg').innerText = cartDrawerShippingMsg;
                }
              } else {
                const remainingAmount = cartDrawerShippingdigit - totalsTotalValue;
                if (cartDrawerShippingMsgDigit) {
                  cartDrawerShippingMsgDigit.innerText = currencydigit + Number(remainingAmount).toFixed(2);
                }
              }
              if (progressBar) {
                progressBar.style.width = Math.floor(progressPercentage) + '%';
              }
            }
            updateProgressBar();
          }, 500);
        } else {
          // free shipping update for cart page on quantity change

          setTimeout(function() {
            const cartShippingdigit = parseFloat(
              document
                .querySelector('.free-shipping-message')
                ?.getAttribute('freedigit')
                ?.match(/\d+(?:\d{3})*(?:\.\d+)?/g)
                .join('')
            );
            const cartShippingMsg = document.querySelector('.free-shipping-message')?.getAttribute('limit-reach');
            const cartShippingMsgDigit = document.querySelector('.free-shipping-message [data-left-to-spend]');

            let elThree = document.querySelector('.cart__footer .totals__total-value');
            let totalsTotalValue = elThree ? parseLocaleNumber(elThree.innerText) : null;
            if (!totalsTotalValue) return;
            const currencydigit = document.getElementById('shop-currency-symbol').getAttribute('data-currency-symbol');
            const progressBar = document.querySelector('.free-shipping-section .progress-done');

            function updateProgressBar() {
              if (!cartShippingdigit) return;
              let progressPercentage = (totalsTotalValue / cartShippingdigit) * 100;
              progressPercentage = Math.min(progressPercentage, 100);

              if (progressPercentage >= 100) {
                if (cartShippingMsg) {
                  document.querySelector('.free-shipping-message').innerText = cartShippingMsg;
                }
              } else {
                const remainingAmount = cartShippingdigit - totalsTotalValue;
                if (document.querySelector('.free-shipping-message')?.innerText === cartShippingMsg) {
                  document.querySelector('.free-shipping-message').innerHTML = document
                    .querySelector('#main-cart-label')
                    ?.innerText.trim();
                  document.querySelector('.free-shipping-message [data-left-to-spend]').innerText =
                    currencydigit + Number(remainingAmount).toFixed(2);
                } else if (cartShippingMsgDigit) {
                  cartShippingMsgDigit.innerText = currencydigit + Number(remainingAmount).toFixed(2);
                }
              }
              if (progressBar) {
                progressBar.style.width = Math.floor(progressPercentage) + '%';
              }
            }
            updateProgressBar();
          }, 500);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (parsedState.item_count > 0 && reload) {
          window.location.reload();
        }

        let cartUpdateEvent = new CustomEvent('cart-updated', {
          detail: parsedState
        });
        // console.log('h1h1');
        document.dispatchEvent(cartUpdateEvent);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach(overlay => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(data => {
        this.disableLoading(line);
      });
  }

  /* Update All HTML Structures */

  fullCartUpdate(data) {
    this.getSectionsToRender().forEach(section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      var getHtmlData = data[section.section];
      let shippingBarCheck = document.querySelector('.shipping_bar');
      if (shippingBarCheck != null) {
        let datagetWidth = '';
        if (document.querySelector('.drawer.active .progress-done') != null) {
          datagetWidth = document.querySelector('.drawer.active .progress-done').style.width;
        } else {
          datagetWidth = document.querySelector('.free-shipping-section .progress-done').style.width;
        }
        getHtmlData = getHtmlData.replace(
          '<div class="progress-done" data-done="20" style="width: 20%;"></div>',
          '<div class="progress-done" data-done="20" style="width: ' + datagetWidth + '"></div>'
        );
      }
      elementToReplace.innerHTML = this.getSectionInnerHTML(getHtmlData, section.selector);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = `${message}`;
    }

    if (message === '') {
      if (lineItemError) {
        lineItemError.classList.remove('isError');
      }
    } else {
      if (lineItemError) {
        lineItemError.classList.add('isError');
      }
      const closeIcon = lineItemError.querySelector('.close-icon');
      if (closeIcon) {
        closeIcon.addEventListener('click', () => {
          lineItemError.querySelector('.cart-item__error-text').innerHTML = '';
          lineItemError.classList.remove('isError');
        });
      }
    }

    const mobileLineItemError = document.querySelector(`#Line-item-error-${line}.error_mobile`);
    if (mobileLineItemError) {
      mobileLineItemError.querySelector('.cart-item__error-text').innerHTML = `${message}`;
      if (message === '') {
        mobileLineItemError.classList.remove('isError');
      } else {
        mobileLineItemError.classList.add('isError');
      }
    }

    document.querySelector('.cart-item__error.error_mobile .close-icon')?.addEventListener('click', function() {
      this.closest('.cart-item__error').classList.remove('isError');
    });

    document.querySelector('.cart-item__error .close-icon')?.addEventListener('click', function() {
      this.closest('.cart-item__error').classList.remove('isError');
    });

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach(overlay => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach(overlay => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach(overlay => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Preserve your existing setTimeout function for free shipping bar
setTimeout(function() {
  const cartShippingdigit = parseFloat(
    document
      .querySelector('.free-shipping-message')
      ?.getAttribute('freedigit')
      ?.match(/\d+(?:\d{3})*(?:\.\d+)?/g)
      .join('')
  );
  const cartShippingMsg = document.querySelector('.free-shipping-message')?.getAttribute('limit-reach');
  const cartShippingMsgDigit = document.querySelector('.free-shipping-message [data-left-to-spend]');

  let elFour = document.querySelector('.cart__footer .totals__total-value');
  let totalsTotalValue = elFour ? parseLocaleNumber(elFour.innerText) : null;
  if (!totalsTotalValue) return;
  const currencydigit = document.getElementById('shop-currency-symbol').getAttribute('data-currency-symbol');
  const progressBar = document.querySelector('.free-shipping-section .progress-done');

  function updateProgressBar() {
    if (!cartShippingdigit) return;
    let progressPercentage = (totalsTotalValue / cartShippingdigit) * 100;
    progressPercentage = Math.min(progressPercentage, 100);

    if (progressPercentage >= 100) {
      if (cartShippingMsg) {
        document.querySelector('.free-shipping-message').innerText = cartShippingMsg;
      }
    } else {
      const remainingAmount = cartShippingdigit - totalsTotalValue;
      if (cartShippingMsgDigit) {
        cartShippingMsgDigit.innerText = currencydigit + Number(remainingAmount).toFixed(2);
      }
    }
    if (progressBar) {
      progressBar.style.width = Math.floor(progressPercentage) + '%';
    }
  }
  updateProgressBar();
}, 30);

function discount_cart_ninja_cart_total_rebuild() {
  if (
    discountNinja.api.cart.content.cart_level_discount_applications.length > 0 &&
    document.querySelector('.cart-subtotal-block .discounts')
  ) {
    let discount_titles_list = document.querySelector('.cart-subtotal-block .discounts');
    let discount_titles_element = discount_titles_list
      .querySelector('.cart-subtotal-block .discounts li:last-child')
      .cloneNode(true);

    let total_element = document.querySelector('.cart-subtotal-block .totals__total-value');
    let new_sub_total = discountNinjaContext.MoneyFormat.replace(
      '{{amount}}',
      (discountNinja.api.cart.content.total_price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
    new_sub_total += total_element.dataset.currency ? ' ' + Shopify.currency.active : '';
    total_element.innerHTML = new_sub_total;

    //There is a discount from Discount Ninja
    discountNinja.api.cart.content.cart_level_discount_applications.forEach(item => {
      if (document.querySelector(`.cart-subtotal-block .discounts li[data-title="${item.title}"]`)) {
        return false;
      }

      let new_element = discount_titles_element.cloneNode(true);
      new_element.classList.remove('dummy');

      let discount_value = (item.total_allocated_amount / 100).toFixed(2);
      discount_value = discountNinjaContext.MoneyFormat.replace('{{amount}}', discount_value);

      new_element.setAttribute('data-title', item.title);
      new_element.querySelector('.discount-title').innerHTML = item.title;
      new_element.querySelector('.discount-value').innerHTML = discount_value;
      document.querySelector('.cart-subtotal-block .discounts').appendChild(new_element);
    });
  }
}
